export const products = $state({
  lAvailableTreatments: [], // de lijst die met de ajax call terug komt uit het backend
  lItems: [], // die l voor de naam is nog legacy.. het is een array
  aRecommendedProductIDs: [],
  aAvailableRestaurantTimes: []
});

window.hmk_products = () => {
  console.log($state.snapshot(products))
}
